// extracted by mini-css-extract-plugin
export default {"block":"HowToUse_block__1dXSA","cards":"HowToUse_cards__19A1k"};